/* /tw/lang.js */
export default {
    "CustomerLogin": "Customer Login" ,
    "Account": "Account(Email)" ,
    "Password": "Password",
    "Login": "Login"
}
